export default function generateSessionId(): string {
    return "fsr" + Math.random().toString(36).substring(2, 18);
}
